import React from 'react';
import { scrollToCompra } from '../utils/scroll';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  href?: string;
  className?: string;
  pulse?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  pulse = true,
  fullWidth = true
}: ButtonProps) {
  const baseClasses = 'relative inline-flex items-center justify-center font-montserrat font-black text-brand-dark bg-brand-cta hover:bg-brand-ctaDark transition-all duration-300 rounded-lg shadow-[0_4px_0_rgb(0,153,204)] hover:shadow-[0_2px_0_rgb(0,153,204)] hover:translate-y-[2px] active:shadow-none active:translate-y-[4px] px-4 py-3 md:px-6 md:py-4 text-base md:text-lg lg:text-xl text-center uppercase tracking-wide';
  const pulseClasses = pulse ? 'animate-pulse-fast hover:animate-none' : '';
  const widthClasses = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e);
    } else if (!href) {
      scrollToCompra(e);
    }
  };
  if (href) {
    return <a href={href} className={`${baseClasses} ${pulseClasses} ${widthClasses} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-44">
        {children}
      </a>;
  }
  return <button onClick={handleClick} className={`${baseClasses} ${pulseClasses} ${widthClasses} ${className}`} data-id="element-45">
      {children}
    </button>;
}